"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = App;
var _react = _interopRequireDefault(require("react"));
var _saraivaUi = require("@minha-biblioteca/saraiva-ui");
var _Home = _interopRequireDefault(require("./components/Home"));
var _Auth = _interopRequireDefault(require("./contexts/Auth"));
var _Highlight = _interopRequireDefault(require("./contexts/Highlight"));
var _HighlightList = _interopRequireDefault(require("./contexts/HighlightList"));
var _Theme = _interopRequireDefault(require("./contexts/Theme"));
var _Bookmarks = require("./contexts/Bookmarks");
var _Copy = _interopRequireDefault(require("./contexts/Copy"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function App(props) {
  return /*#__PURE__*/_react.default.createElement(_saraivaUi.SaraivaTheme, null, /*#__PURE__*/_react.default.createElement(_Auth.default, {
    value: props
  }, /*#__PURE__*/_react.default.createElement(_Theme.default, null, /*#__PURE__*/_react.default.createElement(_Highlight.default, null, /*#__PURE__*/_react.default.createElement(_HighlightList.default, null, /*#__PURE__*/_react.default.createElement(_Bookmarks.BookmarksProvider, null, /*#__PURE__*/_react.default.createElement(_Copy.default, null, /*#__PURE__*/_react.default.createElement(_Home.default, null))))))));
}